<ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
<ng-template #contentTemplate>
  <div class="d-flex flex-column h-100">
    <div class="offcanvas-header d-flex justify-content-between py-0">
      <h4 class="offcanvas-title mt-0">Pod : {{ selectedPod.podName }}</h4>
      <div>
        <button
          type="button"
          class="actionBtn"
          placement="top auto"
          container="body"
          triggers="hover"
          (click)="refreshComponent()"
          ngbTooltip="Refresh Details"
        >
          <span class="bi bi-arrow-clockwise"></span>
        </button>
        <button
          type="button"
          class="actionBtn"
          (click)="close()"
          matTooltip="Close"
        >
          <mat-icon style="color: red">close</mat-icon>
        </button>
      </div>
    </div>
    <div class="offcanvas-body flex-grow-1 py-0 pt-1 d-flex flex-column">
      <div class="options">
        <p class="active" title="Details of {{ selectedPod.podName }}">
          Pod Details
        </p>
        <ng-container *ngIf="node?.state != 'Unassigned'">
          <div
            class="btn-group"
            ngbDropdown
            container="body"
            role="group"
            aria-label="Button group with nested dropdown"
          >
            <!-- <i title="Node actions"
            class="btn dropdown-toggle-split bi bi-three-dots p-0 border-0 bg-transparent synchpc-primary"
            ngbDropdownToggle></i> -->
            <button class="default-btn" ngbDropdownToggle>Actions</button>
            <div class="dropdown-menu" ngbDropdownMenu>
              <button
                ngbDropdownItem
                *ngFor="let action of returnActionsAvailableForPod()"
                (click)="emitPodAction(action)"
                [title]="action.title"
                [class.disabled]="action.disabled"
              >
                <i
                  class="bi"
                  [ngClass]="action.icon"
                  style="color: var(--s-primary-color)"
                ></i>
                &nbsp;<span
                  class="fs-6 text-dark"
                  style="font-size: 13px !important"
                  >{{ action.name }}</span
                >
              </button>
            </div>
          </div>
        </ng-container>
        <button
          *ngIf="podDetails?.status?.phase == 'Running'"
          type="button"
          class="actionBtn"
          placement="top auto"
          container="body"
          triggers="hover"
          (click)="runCommand()"
          ngbTooltip="Connect to a pod terminal"
        >
          <span class="bi bi-code-slash"></span>
          <span class="button-animation">Connect</span>
        </button>
      </div>
      <div class="childs flex-grow-1">
        <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          [(selectedIndex)]="currentActiveIndex"
        >
          <mat-tab label="MetaData" class="p-1">
            @if (podDetails) {
            <div class="job-details-container">
              <mat-card class="mat-elevation-z2 main-card">
                <mat-card-content class="pt-1 px-2">
                  <section class="job-overview">
                    <div class="info-grid-overview">
                      <div class="info-item">
                        <mat-icon class="bi bi-collection-fill"></mat-icon>
                        <div class="info-content">
                          <span class="label">Pod Name:</span>
                          <span class="value">{{
                            podDetails.metadata.name || "NA"
                          }}</span>
                        </div>
                      </div>
                      <div class="info-item">
                        <mat-icon
                          class="bi bi-stack"
                          style="height: 26px"
                        ></mat-icon>
                        <div class="info-content">
                          <span class="label">NameSpace:</span>
                          <span class="value">{{
                            podDetails.metadata.namespace || "NA"
                          }}</span>
                        </div>
                      </div>
                      <div class="info-item">
                        <mat-icon class="bi bi-display-fill">person</mat-icon>
                        <div class="info-content">
                          <span class="label">Node Allocated:</span>
                          <span class="value">{{
                            podDetails.spec.nodeName || "NA"
                          }}</span>
                        </div>
                      </div>
                      <div class="info-item">
                        <mat-icon class="bi bi-list"></mat-icon>
                        <div class="info-content">
                          <span class="label">Job Name:</span>
                          <span
                            style="cursor: pointer"
                            (click)="redirectTo()"
                            class="value"
                            >{{ getJobName() || "NA" }}
                            <span class="value"
                              ><i class="bi bi-box-arrow-up-right"></i></span
                          ></span>
                        </div>
                      </div>
                      <div class="info-item">
                        <mat-icon class="bi bi-clock">person</mat-icon>
                        <div class="info-content">
                          <span class="label">Creation Time:</span>
                          <span class="value">{{
                            podDetails.metadata.creationTimestamp
                              | date : "medium"
                          }}</span>
                        </div>
                      </div>
                      <div class="info-item">
                        <mat-icon class="bi bi-people-fill">person</mat-icon>
                        <div class="info-content">
                          <span class="label">Phase:</span>
                          <span class="value">{{
                            podDetails.status.phase || "NA"
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </section>

                  <mat-divider></mat-divider>

                  <section class="additional-information">
                    <h2>Additional Information</h2>
                    <div class="info-grid-compact">
                      <div class="info-item-compact">
                        <span class="label">Pod Name:</span>
                        <span class="value">{{
                          podDetails.metadata.name || "NA"
                        }}</span>
                      </div>
                      <div class="info-item-compact">
                        <span class="label">Name Space:</span>
                        <span class="value">{{
                          podDetails.metadata.namespace || "NA"
                        }}</span>
                      </div>
                      <div class="info-item-compact">
                        <span class="label">Creation Time:</span>
                        <span class="value">{{
                          podDetails.metadata.creationTimestamp || "NA"
                        }}</span>
                      </div>
                      <div class="info-item-compact">
                        <span class="label">Start Time:</span>
                        <span class="value">{{
                          podDetails.status.startTime || "NA"
                        }}</span>
                      </div>
                      <div class="info-item-compact">
                        <span class="label">Phase:</span>
                        <span class="value">{{
                          podDetails.status.phase || "NA"
                        }}</span>
                      </div>
                      <div class="info-item-compact">
                        <span class="label">Pod IP:</span>
                        <span class="value">{{
                          podDetails.status.podIP || "NA"
                        }}</span>
                      </div>
                      <div class="info-item-compact">
                        <span class="label">Host IP:</span>
                        <span class="value">{{
                          podDetails.status.hostIP || "NA"
                        }}</span>
                      </div>
                      <div class="info-item-compact">
                        <span class="label">Scheduler Name:</span>
                        <span class="value">{{
                          podDetails.spec.schedulerName || "NA"
                        }}</span>
                      </div>
                      <div class="info-item-compact">
                        <span class="label">Service Account</span>
                        <span class="value">{{
                          podDetails.spec.schedulerName || "NA"
                        }}</span>
                      </div>
                      <div class="info-item-compact">
                        <span class="label">Service Account Name</span>
                        <span class="value">{{
                          podDetails.spec.serviceAccountName || "NA"
                        }}</span>
                      </div>
                      <!--<div class="info-item-compact">
    <span class="label">Reason</span>
    <span class="value">{{ podDetails.status.serviceAccountName || "NA"}}</span>
  </div>-->
                    </div>
                  </section>
                </mat-card-content>
              </mat-card>
            </div>
            } @else {
            <ng-container *ngTemplateOutlet="noContent"></ng-container>
            <div class="h-100 w-100">
              <ngx-spinner
                bdColor="rgba(0,0,0,0)"
                size="default"
                zIndex="1"
                color="var(--s-primary-color)"
                type="ball-spin"
                [fullScreen]="false"
                name="podSpinner"
              >
              </ngx-spinner>
            </div>
            }
          </mat-tab>
          <mat-tab label="Containers" class="p-1">
            @if (podDetails) {
            <div class="job-details-container">
              <mat-card class="mat-elevation-z2 main-card">
                <mat-card-content class="pt-1 px-2">
                  <section class="job-overview">
                    <div class="info-grid-overview">
                      <div class="info-item">
                        <mat-icon class="bi bi-box-fill">person</mat-icon>
                        <div class="info-content">
                          <span class="label">Num of Containers:</span>
                          <span class="value">{{
                            numOfContainers || "NA"
                          }}</span>
                        </div>
                      </div>
                      <div class="info-item">
                        <mat-icon
                          class="bi bi-person-walking"
                          style="height: 26px"
                        ></mat-icon>
                        <div class="info-content">
                          <span class="label">Running:</span>
                          <span class="value">{{
                            runningContainers == 0
                              ? "0"
                              : runningContainers || "NA"
                          }}</span>
                        </div>
                      </div>
                      <div class="info-item">
                        <mat-icon class="bi bi-exclamation-triangle-fill"
                          >person</mat-icon
                        >
                        <div class="info-content">
                          <span class="label">Terminated:</span>
                          <span class="value">{{
                            terminatedConatiners == 0
                              ? "0"
                              : terminatedConatiners || "NA"
                          }}</span>
                        </div>
                      </div>
                      <div class="info-item">
                        <mat-icon class="bi bi-hourglass-split"
                          >person</mat-icon
                        >
                        <div class="info-content">
                          <span class="label">Waiting:</span>
                          <span class="value">{{
                            waitingContainers == 0
                              ? "0"
                              : waitingContainers || "NA"
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </section>

                  <mat-divider></mat-divider>

                  <section class="additional-information">
                    <div
                      class="listTable flex-grow-1"
                      style="white-space: nowrap"
                    >
                      <div class="row">
                        <div
                          class="col-12"
                          *ngFor="
                            let container of containerListUI;
                            let i = index
                          "
                        >
                          <div class="card shadow-sm w-100 mb-3">
                            <div class="card-body content-12px">
                              <!-- Header -->
                              <h4 class="card-title mb-3">
                                <b>{{ i + 1 }}. {{ container.name }}</b>
                              </h4>
                              <p>
                                <b>Container Image:</b> {{ container.image }}
                              </p>

                              <div class="row">
                                <!-- Left Column -->
                                <div class="col-md-6">
                                  <p>
                                    <b>Ready:</b>
                                    {{ container.ready ? "Yes" : "No" }}
                                  </p>
                                  <p>
                                    <b>Started:</b>
                                    {{ container.started ? "Yes" : "No" }}
                                  </p>
                                  <p>
                                    <b>Restart Count:</b>
                                    {{ container.restartCount }}
                                  </p>
                                  <p>
                                    <b>State:</b>
                                    {{
                                      container.state.running?.startedAt
                                        ? "Running"
                                        : container.state.terminated?.startedAt
                                        ? "Terminated"
                                        : "Waiting"
                                    }}
                                  </p>
                                </div>

                                <!-- Right Column -->
                                <div class="col-md-6">
                                  <div *ngIf="container.Resources">
                                    <p><b>Resources:</b></p>
                                    <ul class="list-unstyled mb-2">
                                      <li>
                                        CPU (limit/request):
                                        {{ container.Resources?.limits?.cpu }} /
                                        {{ container.Resources?.requests?.cpu }}
                                      </li>
                                      <li>
                                        Memory (limit/request):
                                        {{
                                          container.Resources?.limits?.memory
                                        }}
                                        /
                                        {{
                                          container.Resources?.requests?.memory
                                        }}
                                      </li>
                                      <li>
                                        GPU (limit/request):
                                        {{ container.Resources?.limits?.gpu }} /
                                        {{ container.Resources?.requests?.gpu }}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>

                              <!-- Volume Mounts -->
                              <div
                                *ngIf="
                                  container.VolumeMounts &&
                                  container.VolumeMounts.length > 0
                                "
                              >
                                <p class="mt-3"><b>Volume Mounts:</b></p>
                                <div class="d-flex flex-wrap gap-2">
                                  <span
                                    class="badge border mount-class"
                                    *ngFor="let vm of container.VolumeMounts"
                                  >
                                    {{ vm.name }} - {{ vm.mountPath }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!--<div class="d-flex mt-1 " *ngIf="available === true">
                        <pagination-controls *ngIf="available === true" class="my-pagination"
                                             (pageChange)="p = $event"></pagination-controls>
                      </div>-->
                    </div>
                    <p id="emptyError" *ngIf="available === false">
                      No Pods are available for selected deployment
                    </p>
                  </section>
                </mat-card-content>
              </mat-card>
            </div>
            } @else {
            <ng-container *ngTemplateOutlet="noContent"></ng-container>
            <div class="h-100 w-100">
              <ngx-spinner
                bdColor="rgba(0,0,0,0)"
                size="default"
                zIndex="1"
                color="var(--s-primary-color)"
                type="ball-spin"
                [fullScreen]="false"
                name="podSpinner"
              >
              </ngx-spinner>
            </div>
            }
          </mat-tab>
        </mat-tab-group>

        <!--<app-json-viewer [data]="podDetails"></app-json-viewer>-->
      </div>
    </div>
  </div>
</ng-template>
<ng-template #noContent>
  <div class="d-flex flex-column h-100 w-100">
    <p class="pt-5 text-center">Something went wrong!</p>
  </div>
</ng-template>
